import { logout } from '../api/axios';
import useAuth from './useAuth';

const useLogout = () => {

  const { auth, setAuth } = useAuth();

  // LE PONGO ESTE NOMBRE DE MIERDA PARA DEJAR LIBRE EL NOMBRE logout
  // QUE ES EL DE LA API
  const useLogoutLogout = async () => {

    try {

      await logout(auth);

    } catch (err) {

      console.log(err);

    } finally {

      setAuth({});

    }

  }

  return useLogoutLogout;

}

export default useLogout;
